import React, { Component } from 'react';
import { Button, Icon, Modal, ModalFooter } from 'straightline-ui';

export default class VideoModal extends Component {
  state = { isOpen: false };

  playVideo = () => {
    this.video.play();
  };

  pauseVideo = () => {
    this.video.pause();
  };

  toggleModal = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const { isOpen } = this.state;
    return (
      <div className="d-inline-block">
        <Button {...this.props} onClick={this.toggleModal} color="white">
          <Icon type="play-circle" className="mr-2" />
          Shipper Video
        </Button>
        <Modal
          isOpen={isOpen}
          size="lg"
          mountOnEnter={false}
          unmountOnExit={false}
          onOpened={this.playVideo}
          onClosed={this.pauseVideo}
        >
          {() => (
            <React.Fragment>
              <video
                width="100%"
                controls={true}
                ref={(ref) => {
                  this.video = ref;
                }}
              >
                <source src="https://www.bookstraightline.com/videos/shipper-promo.mp4" />
              </video>
              <ModalFooter>
                <Button color="default" onClick={this.toggleModal}>
                  Close
                </Button>
                <a
                  href="https://www.bookstraightline.com/shippers"
                  className="btn btn-primary"
                >
                  Learn More
                </a>
              </ModalFooter>
            </React.Fragment>
          )}
        </Modal>
      </div>
    );
  }
}
